import React from 'react';
import StringFieldProto from './phone-proto.jsx';


export default function renderStringInView(id, props) {
    return <StringFieldProto renderMode="view" id={id} {...props} />;
}